import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import "./Autocomplete.css";

class Autocomplete extends Component {
  static propTypes = {
    suggestions: PropTypes.instanceOf(Array),
  };
  static defaultProps = {
    suggestions: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: "",
    };
  }

  onChange = (e) => {
    let { suggestions, onClientChange, name } = this.props;
    const userInput = e.currentTarget.value;
    suggestions = suggestions.filter((m) => m.text != null);
    const filteredSuggestions = suggestions.filter(
      (suggestion) =>
        suggestion.text.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );

    this.setState({
      activeSuggestion: 0,
      filteredSuggestions,
      showSuggestions: true,
      userInput: e.currentTarget.value,
    });

    onClientChange(name, e.currentTarget.value);
  };

  onClick = (e) => {
    let { onClientChange, name } = this.props;
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: e.currentTarget.innerText,
    });
    onClientChange(name, e.currentTarget.innerText);
  };

  onKeyDown = (e) => {
    const { activeSuggestion, filteredSuggestions } = this.state;
    let { onClientChange, name } = this.props;
    if (e.keyCode === 13) {
      this.setState({
        activeSuggestion: 0,
        showSuggestions: false,
        userInput: filteredSuggestions[activeSuggestion],
      });

      onClientChange(name, filteredSuggestions[activeSuggestion]);
    } else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }
      this.setState({ activeSuggestion: activeSuggestion - 1 });
    } else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }
      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  };
  render() {
    const {
      onChange,
      onClick,
      onKeyDown,
      state: {
        activeSuggestion,
        filteredSuggestions,
        showSuggestions,
        userInput,
      },
    } = this;
    const { id, name, value, maxLength, className, placeholder } = this.props;
    let suggestionsListComponent;

    if (showSuggestions && userInput) {
      if (filteredSuggestions.length) {
        suggestionsListComponent = (
          <ul className="suggestions" key="suggestionsKey">
            {filteredSuggestions.map((suggestion, index) => {
              let className;
              if (index === activeSuggestion) {
                className = "suggestion-active";
              }
              return (
                <li className={className} key={suggestion} onClick={onClick}>
                  {suggestion.text}
                </li>
              );
            })}
          </ul>
        );
      }
      //   else {
      //     suggestionsListComponent = (
      //       <div class="no-suggestions">
      //         <em>No suggestions, you're on your own!</em>
      //       </div>
      //     );
      //   }
    }
    return (
      <Fragment>
        <input
          autoComplete="off"
          id={id}
          name={name}
          maxLength={maxLength}
          className={className}
          placeholder={placeholder}
          type="text"
          onChange={onChange}
          onKeyDown={onKeyDown}
          value={value}
        />
        {suggestionsListComponent}
      </Fragment>
    );
  }
}
export default Autocomplete;
